import React from 'react'
import reactStamp from 'react-stamp'
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

import './appointments.css'

export default reactStamp(React).compose({

    init(){
        this.handleChange = this.handleChange.bind(this);
    },

    render() {
        return this.props.slots !== undefined ? (
            <div>
                <RadioButtonGroup
                    name="slots"
                    onChange={this.handleChange}
                    className="slots"
                >
                    {this.getButtons()}

                </RadioButtonGroup>
            </div>
        ) : null
    },

    handleChange(e){
        this.props.handleSlotChange(e.target.value);
    },

    getButtons(){
        const styles = {
            radioButton: {
                width: 200,
                marginTop: 35,
            },
        };
        let slots = [];
        for (let slotIndex in this.props.slots) {
            slots.push(
                <RadioButton
                    value={this.props.slots[slotIndex].id+"/"+this.props.slots[slotIndex].scheduleID}
                    label={this.props.slots[slotIndex].start+" - "+this.props.slots[slotIndex].end}
                    style={styles.radioButton}
                />
            )
        }
        return slots;
    }

});



/** WEBPACK FOOTER **
 ** ./src/app/components/Appointments/FreeSlots.js
 **/